import { Button } from "@material-ui/core";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import React, { Fragment } from "react";
import Prompt from "../../components/Prompt";
import adminStore from "../../stores/adminStore";
import DataTable from "./../../components/DataTable";
import Confirm from "../../components/Confirm";
@observer
class Charges extends React.Component {
  state = {
    isPromptOpened: false,
    isConfirmOpened: false,
    activeCharge: {},
  };

  closeModal() {
    this.setState({
      isPromptOpened: false,
      isConfirmOpened: false,
      activeCharge: {},
    });
  }

  render() {
    const { charges } = adminStore;
    if (!charges) {
      return <div></div>;
    }
    return (
      <Fragment>
        <Button
          variant="contained"
          color="primary"
          onClick={() =>
            this.setState({ isPromptOpened: true, activeCharge: {} })
          }
        >
          Nuevo Cargo
        </Button>
        <Prompt
          isOpen={this.state.isPromptOpened}
          field={{
            type: "text",
            label: "Cargo",
            value: this.state.activeCharge.name,
          }}
          placeholder={this.state.activeCharge.name}
          title={"Cargo"}
          onClose={this.closeModal}
          onSubmit={async (name) => {
            await adminStore.submitCharge({ ...this.state.activeCharge, name });
            this.closeModal();
          }}
        />
        <Confirm
          isOpen={this.state.isConfirmOpened}
          onNo={() => this.closeModal()}
          onYes={async () => {
            await adminStore.deleteCharge(this.state.activeCharge.id);
            this.closeModal();
          }}
          onClose={() => this.closeModal()}
          title="Atencion"
          text={`Esta accion borrar el cargo ${this.state.activeCharge.name}, desea continuar?`}
        />
        <DataTable
          data={charges}
          fields={["id", "name"]}
          fieldNames={{
            id: "#",
            name: "Nombre",
          }}
          onEdit={(charge) => {
            this.setState({
              isPromptOpened: true,
              activeCharge: toJS(charge),
            });
          }}
          onDelete={(charge) =>
            this.setState({
              isConfirmOpened: true,
              activeCharge: charge,
            })
          }
        />
      </Fragment>
    );
  }
}

export { Charges };
